// extracted by mini-css-extract-plugin
module.exports = {"box":"documents_box__bGa_5"};